import { SupportRequest } from '@/app/entities/SupportRequest'

export interface SupportRequester {
  name?: string
  cpf?: string
  phone?: string
  email?: string
  hasSeller: boolean
  isUnauthenticated: boolean
  isWhatsappDirect: boolean
}

/**
 * Quem abriu o chamado pode vir de dois lugares: `seller` (vendedor com cadastro)
 * ou `metadata.contact` (o que foi digitado no formulário público).
 */
export const resolveRequester = (data: SupportRequest): SupportRequester => {
  const seller = data.seller?.id ? data.seller : undefined
  const isUnauthenticated = data.metadata?.unauthenticated === true
  const contact = isUnauthenticated ? data.metadata?.contact : undefined

  return {
    name: seller?.name ?? contact?.name,
    cpf: seller?.cpf ?? contact?.cpf,
    phone: seller?.phone ?? contact?.phone,
    email: seller?.email ?? contact?.email,
    hasSeller: !!seller,
    isUnauthenticated,
    isWhatsappDirect: data.metadata?.whatsappDirect === true,
  }
}
